export default {
  'goldkid-conditions:title': 'Условия',
  'goldkid-conditions-table-row-1:key': 'Возраст',
  'goldkid-conditions-table-row-1:value': 'от 6 до 16 лет',
  'goldkid-conditions-table-row-2:key': 'Годовое <br> обслуживание',
  'goldkid-conditions-table-row-2:value': '0&nbsp;₸',
  'goldkid-conditions-table-row-3:key': 'Пополнение <br> с Kaspi Gold <br> родителя',
  'goldkid-conditions-table-row-3:value': 'до 1 млн&nbsp;₸ в день',
  'goldkid-conditions-table-row-4:key': 'Пополнение <br> с Kaspi Gold <br> других клиентов',
  'goldkid-conditions-table-row-4:value': 'до 100 000&nbsp;₸  в месяц',
  'goldkid-conditions-table-row-5:key': 'Перевод <br> на Kaspi Gold других клиентов',
  'goldkid-conditions-table-row-5:value': 'до 100 000&nbsp;₸  в месяц',
  'goldkid-conditions-table-row-6:key': 'Снятие наличных',
  'goldkid-conditions-table-row-6:value': 'до 10 000&nbsp;₸  в месяц',
  'goldkid-conditions-table-row-7:key': 'Доступные операции',
  'goldkid-conditions-table-row-7:value': 'Оплата покупок, переводы, платежи (мобильный, билеты на мероприятия, игры, прокат велосипедов, пополнение транспортных карт)',
  'goldkid-conditions-table-row-8:key': 'Недоступные операции',
  'goldkid-conditions-table-row-8:value': 'Оформление кредитов, открытие Kaspi Депозита, покупки в Магазине на Kaspi.kz: переводы на карты других банков'
}
